/**
 * The saved "active workspace" choice, shared by WorkspaceProvider and the
 * pages that run outside it (/auth and /accept-invitation are not wrapped in
 * a WorkspaceProvider, so its setActiveWorkspace is unavailable there).
 *
 * Writing the key is safe from anywhere: WorkspaceProvider only honours the
 * saved id when it appears in the user's freshly fetched memberships, so a
 * bogus or stale id can never grant access.
 *
 * The key is `-v2`: the old key (`nynch:active-workspace:`) held the owner-first
 * default that the app wrote on every multi-workspace load, not a choice the
 * person made. Renaming it means no device keeps that old default; the main
 * workspace under the one rule is used until the person switches on purpose.
 */
export const activeWorkspaceStorageKey = (userId: string) => `nynch:active-workspace-v2:${userId}`;

export function persistActiveWorkspaceSelection(userId: string, workspaceId: string): boolean {
  try {
    localStorage.setItem(activeWorkspaceStorageKey(userId), workspaceId);
    return true;
  } catch {
    return false;
  }
}
